import Loadable from 'react-loadable'

import MainLayout from '../../components/admin/layout/MainLayout'
import LoadingPage from '../../components/admin/layout/Loading'

const systemPage = Loadable({
  loader: () => import('../../pages/admin/Test/Test1'),
  loading: LoadingPage,
})

const systemRoutes = [
  {
    path: '/admin/test',
    exact: true,
    requiredAuth: true,
    component: systemPage,
    layout: MainLayout,
  },
]

export default systemRoutes
